import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, SimpleChanges, Input, OnChanges, OnDestroy, Output, EventEmitter } from '@angular/core';

import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';

import './iframeResizer';
declare function iFrameResize(options: any, selector: string): object[];

@Component({
  selector: 'ap-frame',
  templateUrl: './frame.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrameComponent implements OnInit, OnChanges, OnDestroy {

  private _iframe: any;
  private _debugLog = false;
  private _origin: string;
  private _hasFinishedLoading = false;

  @Input() url: string;
  @Input() useFrameResizer: boolean = false;
  @Input() width: string;
  @Input() height: string;
  @Output() loaded = new EventEmitter();
  @Output() messages = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    fromEvent(window, 'message')
      .pipe(
        filter(p => (<any>p).origin === window.location.origin),
        untilDestroyed(this)
      )
      .subscribe(p => {
        this.messages.emit((<any>p).data);
      });
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if (simpleChanges.url != null && simpleChanges.url.currentValue != null) {
      this._origin = this.getOrigin(simpleChanges.url.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.close();
  }

  public close(): void {
    if (this._iframe != null) {
      this._iframe.iFrameResizer.close();
    }
  }

  onFrameLoaded(): void {
    if (!this._hasFinishedLoading) {
      if (this.useFrameResizer) {
        setTimeout(() => {
          this.initFrameResize();
        }, 1000); // NOTE: A delay is required to get the PE URL to load properly.
      } else {
        this.loaded.emit();
        this._hasFinishedLoading = true;
      }
    }
  }

  private initFrameResize(): void {
    if (this._iframe != null) {
      return;
    }

    const iframes = iFrameResize({
        log: this._debugLog,
        targetOrigin: this._origin,
        checkOrigin: [this._origin]
      },
      '#apFrame');

    if (iframes == null || iframes.length !== 1) {
      setTimeout(() => {
        this.initFrameResize();
      }, 1000); // NOTE: A delay is required to get the PE URL to load properly.

      return;
    }

    this._iframe = iframes[0];
    this._iframe.src = this._iframe.src; // NOTE: The src needs to be reset after the delay to get the PE URL to load properly.
    this.loaded.emit();
    this._hasFinishedLoading = true;
  }

  private getOrigin(url: string): string {
    if (typeof window.URL === 'function') {
      return new window.URL(url).origin;
    } else {
      const parser = document.createElement('a');
      parser.href = url;
      const originUrl = `${parser.protocol}//${parser.host}`.replace(':443', '');
      return originUrl;
    }
  }

}
